import { isNumber } from '@common/util/types';
import { nowTick, TickRange } from '@common/valueSeries';
import { useMemo } from 'react';
import { TriangleDown } from '../icons';
import { MotionBox } from '../Motion';
import { chartTheme, ScaleTickRange } from './chartHelper';
import VerticalGridLine from './VerticalGridline';

export const useTodayX = ({
    range,
    xScale,
}: {
    range: TickRange;
    xScale: ScaleTickRange;
}): number | undefined => {
    const todayDate = nowTick(range.unit).date;
    return useMemo(() => xScale(todayDate) ?? undefined, [xScale, todayDate]);
};

interface TodayLineProps {
    todayX: number | undefined;
    innerHeight: number;
}

export function TodayLine({ todayX, innerHeight }: TodayLineProps) {
    if (!isNumber(todayX)) return null;
    return <VerticalGridLine x={todayX} height={innerHeight} isAnimated />;
}

interface TodayLabelProps {
    todayX?: number;
    marginLeft: number;
}

export function TodayLabel({ todayX, marginLeft }: TodayLabelProps) {
    if (!isNumber(todayX)) return null;

    return (
        <MotionBox
            position="absolute"
            top={-5}
            animate={{
                left: todayX + marginLeft,
            }}
            transform="translateX(-50%)"
            fontSize={chartTheme.fontSize}
            color={chartTheme.colors.label}
            bg="white"
            zIndex={chartTheme.zIndex.todayLabel}
        >
            Today
            <TriangleDown
                pos="absolute"
                size="xs"
                left="50%"
                transform="translateX(-50%)"
                top={3}
            />
        </MotionBox>
    );
}
